/**
 * P2-06: 资源行 tooltip 内容门控。
 *
 * 对齐旧 game.attachResourceTooltip（game.js:4208-4231）的显示条件：
 * perTick≠0 或转化≠0 或工程师效果≠0 或 perDay≠0 或 perYear≠0（antimatter 特例）
 * 或 kittens 未满员或工程师消耗 → 返回 getDetailedResMap(res) HTML，否则 ''。
 *
 * tooltip 正文**直接调用引擎 game.getDetailedResMap**（game.js:4236-4311），
 * 不做 TS 重实现——逐字对齐由构造保证（含 res.toZero/res.toCap/res.toNextKitten、
 * necrocorn 特例、antimatter 冬季能源警告、usePercentageResourceValues 的 netGain 行）。
 *
 * 锚点/hover 加粗/每 tick 刷新由 TooltipProvider 体系承担（P1-04/05）；
 * hover 加粗对齐旧版 dojo.connect 的 fontWeight bold/normal（game.js:4224-4230）。
 */
import type { GamePage } from "../../bridge/GameBridge";
import type { ResLike } from "./ResourceRow";

/**
 * 返回资源速率格的 tooltip HTML；不满足显示条件时返回空字符串
 * （TooltipProvider 对空内容不显示，对齐 core.js:2700-2702）。
 */
export function getResourceTooltipContent(game: GamePage, res: ResLike): string {
  if (
    game.getResourcePerTick(res.name, false) != 0 ||
    game.getResourcePerTickConvertion(res.name) != 0 ||
    game.workshop.getEffectEngineer(res.name) != 0 ||
    game.getResourcePerDay(res.name) != 0 ||
    game.getResourceOnYearProduction(res.name) != 0 ||
    res.name == "antimatter" ||
    (res.name == "kittens" && game.village.sim.kittens.length < game.village.sim.maxKittens) ||
    game.workshop.getConsumptionEngineers()[res.name]
  ) {
    return game.getDetailedResMap(res);
  }
  return "";
}
